import { Component } from '@angular/core';
import {FooterComponent} from '../footer/footer.component';
import {HeaderComponent} from '../header/header.component';
import {RouterOutlet} from '@angular/router';
import {ToolbarComponent} from '../toolbar/toolbar.component';
import {BannerComponent} from '../banner/banner.component';

@Component({
  selector: 'af-application-frame',
    imports: [
        FooterComponent,
        HeaderComponent,
        RouterOutlet,
        ToolbarComponent,
        BannerComponent
    ],
  templateUrl: './application-frame.component.html',
  styleUrl: './application-frame.component.scss'
})
export class ApplicationFrameComponent {

}
